import { PRODUCT_POINT_MAP } from "./constants";
import { IRewardRecord, IToPointAndRebuy } from "./interface/interface";

/**
 * 숫자를 콤마가 포함된 문자열로 변환
 * @param value 포맷할 숫자
 * @returns 콤마가 포함된 문자열
 */
export const numberFormat = (value: number): string => {
  const NUMBER_FORMAT_REGX = /\B(?=(\d{3})+(?!\d))/g;
  return value.toString().replace(NUMBER_FORMAT_REGX, ",");
};

/**
 * 오늘 날짜를 YYYY-MM-DD 형식으로 반환
 * @returns 오늘 날짜 문자열
 */
export const getCurrentDateString = (): string => {
  return new Date().toISOString().slice(0, 10);
};

/**
 * 보상 기록을 포인트와 리바이로 변환
 * @param rewardRecord 보상 기록
 * @returns 변환된 포인트와 리바이 정보
 */
export const toPointAndRebuy = (
  rewardRecord: IRewardRecord
): IToPointAndRebuy => {
  const productMapping =
    PRODUCT_POINT_MAP[
      rewardRecord.productName as keyof typeof PRODUCT_POINT_MAP
    ];

  if (productMapping) {
    return {
      gameMoney: productMapping.gameMoney,
      rebuy: productMapping.rebuy,
      date: "",
    };
  }

  // 기본값 반환
  return { gameMoney: 0, rebuy: 0, date: "" };
};

/**
 * 두 날짜 사이의 일수 계산
 * @param startDate 시작 날짜
 * @param endDate 종료 날짜
 * @returns 일수
 */
export const getDaysBetweenDates = (startDate: Date, endDate: Date): number => {
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.round((endDate.getTime() - startDate.getTime()) / oneDay);
};

/**
 * 날짜에 일수를 더한 새로운 날짜 반환
 * @param date 기준 날짜
 * @param days 더할 일수
 * @returns 새로운 날짜
 */
export const addDays = (date: Date, days: number): Date => {
  const oneDay = 24 * 60 * 60 * 1000;
  return new Date(date.getTime() + days * oneDay);
};
